export const LOADING_HTML_SNIPPET =
    '<style>.tiretutor-loading{display:flex;justify-content:center;flex-direction:column;margin:0 auto; height: 100%}.tiretutor-loading-container{margin:10px auto;padding:15px;border-radius:5px;box-shadow:0 0 5px rgb(0 0 0 / 25%);background:#fff}.lds-ring{margin:auto;display:inline-block;position:relative;width:80px;height:80px}.lds-ring div{box-sizing:border-box;display:block;position:absolute;width:64px;height:64px;margin:8px;border:8px solid #2181f7;border-radius:50%;animation:lds-ring 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:#2181f7 transparent transparent transparent}.lds-ring div:nth-child(1){animation-delay:-.45s}.lds-ring div:nth-child(2){animation-delay:-.3s}.lds-ring div:nth-child(3){animation-delay:-.15s}@keyframes lds-ring{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style><div class="tiretutor-loading"><div class="tiretutor-loading-container"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div></div>';

export const IFRAME_STYLE_CSS =
    ".tiretutor-iframe{width:100%;min-width:400px;border-width:0}@media all and (max-width:767px){.tiretutor-iframe{min-width:unset}}";

export const IFRAME_AND_CONTAINER_IDS = {
    searchResults: {
        containerId: "tiretutorSearchResults",
        iframeId: "tiretutorSearchResultsIframe",
    },
    scheduleService: {
        containerId: "tiretutorScheduleService",
        iframeId: "tiretutorScheduleServiceIframe",
    },
    search: {
        containerId: "tiretutorSearch",
        iframeId: "tiretutorSearchIframe",
    },
    getAQuote: {
        containerId: "tiretutorGetAQuote",
        iframeId: "tiretutorGetAQuoteIframe",
    },
};
